import React, { Component } from "react";
import LoadingScreen from "react-loading-screen";
import { Row, Col } from "reactstrap";
import "../../styles/estilos.css";
import Page from "components/Page";
import { withRouter, Route, Switch, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { fetchRecuperarCarritoAccP, fetchRecuperarCarritoAP } from "../../redux/actions/aRamoAccidentesPersonales";
import { timingSafeEqual } from "crypto";
import { empresa } from "../../constants";

const paso1 = "cotizacion-accidente-personal-corto-plazo-categoria";
const paso2 = "cotizacion-accidente-personal-corto-plazo-resumen";
const paso3 = "cotizacion-carga-vidas";


class CotizacionAPersonalRecuperarAbierto extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datosRecuperarCarritoAP: "",
      loading: true,
      paso: "",
      idCarrito: "",
    };
  }

  async componentDidMount() {
    const queryParams = new URLSearchParams(this.props.location.search);
    const idCarrito = queryParams.get("idCarrito");

    await this.props.recuperarCarrito({ idCarrito: idCarrito, empresa: empresa });

    console.log('carrito', this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP)

    this.setState({ idCarrito });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.idCarrito !== this.state.idCarrito) {
      let paso = "";
      const pasoAct = this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP.pasoCarrito;
      console.log('carrito', pasoAct)

      switch (pasoAct) {
        case 'inicio':
          paso = paso1;
          break;

        case 'resumen':
          paso = paso2;
          break;

          case 'guardarDataPersonas':
            paso = paso3;
            break;
        
        default:
          paso = pasoAct;
      }

      this.setState({
        paso,
      });
        this.props.history.replace({
        pathname: "/" + paso,
        search: `?id=${this.state.idCarrito}`,
      });  
    }

    console.log(this.state);
  }

  render() {
    const queryParams = new URLSearchParams(this.props.location.search);

    return (
      <LoadingScreen
        loading={this.state.loading}
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        text="Obteniendo datos..."
      >
        <Page
          title="Cotización de D O"
          breadcrumbs={[{ name: "Cotización linea financiera", active: true }]}
        >
          <Row>
            <Col lg={8} md={12} sm={12} xs={12}>
              <div className="container-step">
                <div className="wrapper-step">
                  <div className="arrow-steps clearfix-step">
                    <div className="step"> {` 1. Cotización `} </div>
                    <div className="step current"> {` 2. Resumen `} </div>
                    <div className="step"> {` 3. Confirmación `} </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className="detalle-cotizacion-box"
            >
              {/* <Redirect to={this.state.paso+'?id='+this.state.idCarrito}></Redirect>   */}
            </Col>
            {/*
  
            */}
          </Row>
        </Page>
      </LoadingScreen>
    );
  }
}

const mapStateToProps = (state) => ({
  datosRecuperarCarritoAccP: state.datosRecuperarCarritoAccP,
});

const mapDispatchToProps = (dispatch) => {
  return {
    recuperarCarrito: (datos) => dispatch(fetchRecuperarCarritoAccP(datos)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CotizacionAPersonalRecuperarAbierto)
);
